import { Alert } from "@chakra-ui/react"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import { useMemo } from "react"
import { useScopedTranslation } from "@pathwright/ux/src/components/lng/useScopedTranslation"
import { getAuthFormErrorMessage } from "../utils/authFormError"

const AuthFormAlert = ({
  error
}: {
  /** Pre-translated copy (e.g. URL intent errors) or an `AuthFormError` / other `Error`. */
  error?: string | Error | null
}): JSX.Element | null => {
  const { t } = useScopedTranslation()

  const message = useMemo(() => {
    if (error == null || error === "") {
      return null
    }
    if (typeof error === "string") {
      return error
    }
    return getAuthFormErrorMessage(error, t)
  }, [error, t])

  return message ? (
    <Alert.Root status="error" variant="subtle" wordBreak="break-word">
      <Alert.Indicator>
        <Pathicon icon="caution-octagon" />
      </Alert.Indicator>
      <Alert.Content>
        <Alert.Title>{t("auth.form_alert.an_error_occurred")}:</Alert.Title>
        <Alert.Description>{message}</Alert.Description>
      </Alert.Content>
    </Alert.Root>
  ) : null
}

export default AuthFormAlert
